import React, { FC, ReactNode } from 'react';

import classNames from 'classnames';

import { EvFlexRow, EvSvgIcon } from '@evinced-private/ui-common';

import { ERROR_LAYOUT_DAID } from 'data-automation-ids/data-automation-ids';
import { GeneralError } from 'src/common/components/errors/general-error/GeneralError';

import './PropertyErrLoadViewMsg.scss';

interface ILoadErrorMsgLayout {
	mainTitle: string;
	secondaryMsg: string;
	icon: string;
	className?: string;
	children?: ReactNode;
}
export const LoadErrorMsgLayout: FC<ILoadErrorMsgLayout> = ({
	mainTitle,
	secondaryMsg,
	icon,
	className,
	children
}) => {
	return (
		<div data-automation-id={ERROR_LAYOUT_DAID} className={classNames('error-layout', className)}>
			<GeneralError title="" displayContactInfo={false}>
				<div className="msg-content">
					<EvSvgIcon icon={icon} title={mainTitle} />
					<div className="main-title">{mainTitle}</div>
					<div className="secondary-msg">{secondaryMsg}</div>
					{children && (
						<EvFlexRow justify="CENTER" margin={['LARGE', 'NONE', 'NONE', 'NONE']}>
							{children}
						</EvFlexRow>
					)}
				</div>
			</GeneralError>
		</div>
	);
};
